<template>
    <div class="btn-group" role="group">
        <button type="button" class="btn btn-outline-primary" :class="{ active: value == 0 }" @click="$emit('input', 0)">Все</button>
        <button type="button" class="btn btn-outline-primary" :class="{ active: value == 1 }" @click="$emit('input', 1)">Наличные</button>
        <button type="button" class="btn btn-outline-primary" :class="{ active: value == 2 }" @click="$emit('input', 2)">Безнал</button>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String | Number,
            default: 0
        }
    }
}
</script>
